import { TeamIdSchema, TeamLevelSchema, UserIdSchema } from '@terros/common'
import z from 'zod'

export type WidgetDisplayData = {
  percentage: number
  quartile: number
  rank?: number
  value: number
  goal: number
}

export type ParsedWidgetData = {
  label?: string
  details?: string
  value: string | number
  quartile: number
  percentage?: number
  percentageDisplay?: 'ring' | 'progress'
  rank?: number
  onPress?: VoidFunction
  onRankPress?: VoidFunction
  itemPosthogContext?: Record<string, string | number | boolean | undefined>
}

const TeamViewAsSchema = z.object({
  scope: z.literal('team'),
  scopeId: TeamIdSchema,
  level: TeamLevelSchema,
})

const UserViewAsSchema = z.object({
  scope: z.literal('user'),
  scopeId: UserIdSchema.optional(),
})

const ManagerViewAsSchema = z.object({
  scope: z.literal('manager'),
  scopeId: UserIdSchema.optional(),
})

export const ManagerDashboardViewAsSchema = z.discriminatedUnion('scope', [
  TeamViewAsSchema,
  UserViewAsSchema,
  ManagerViewAsSchema,
])

export type ManagerDashboardViewAs = z.infer<typeof ManagerDashboardViewAsSchema>

export type GroupedParsedWidgetData = {
  value: string
  label: string
  details?: string
  stats: ParsedWidgetData[]
}
